import { cn } from '@/shared/utils';

const FinishedCard = ({ data }) => {
  return (
    <article className="flex flex-1 gap-4 justify-between px-4 py-2 rounded-[8px] bg-[#1E202C] max-md:flex-wrap">
      <header className="space-y-1 flex-1 my-auto min-w-20">
        <h5 className="text-lg font-semibold tracking-tight leading-5">
          {data.playerName}
        </h5>
        <p className="text-sm leading-4">{data.teamName}</p>
      </header>
      <time className="my-auto text-sm text-right leading-4 sm:text-center text-neutral-400 w-32">
        {new Date(data.date).toLocaleString('en-US', {
          weekday: 'long',
          day: '2-digit',
          month: 'short',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        })}
      </time>
      <ul className="flex gap-px my-auto self-stretch text-white flex-wrap w-full sm:w-auto sm:flex-1">
        {data.gameScores.map((score, index) => (
          <li
            key={index}
            className="px-2 py-[7px] bg-[#397D5A] text-sm leading-4 text-center first-of-type:rounded-l last-of-type:rounded-r w-11"
          >
            {score}
          </li>
        ))}
      </ul>
      <aside className="flex items-center h-8 rounded overflow-hidden">
        <div className="flex justify-center items-center bg-[#2D4438] w-[14px] h-full">
          <span className="text-[8px] tracking-wide leading-loose uppercase -rotate-90">
            Total
          </span>
        </div>
        <span
          className={cn(
            'h-full bg-emerald-200 text-black text-3xl font-semibold',
            'flex justify-end items-center px-2 py-2',
            'w-12'
          )}
        >
          {data.totalScore}
        </span>
      </aside>
    </article>
  );
};

export default FinishedCard;
